'use client'

import Cookies from 'js-cookie'
import { useEffect } from 'react'
import { createGlobalState } from 'react-use'

type CookiesState = {
  cookiesExpirationTime: number
  cookiesAccepted: boolean
  acceptCookies: () => void
}

const useCookiesGlobalState = createGlobalState({
  cookiesAccepted: true,
  cookiesExpirationTime: 30,
})

export const useCookies = (): CookiesState => {
  const [state, setState] = useCookiesGlobalState()

  const setCookiesAccepted = (accepted: boolean) => {
    setState((state) => ({ ...state, cookiesAccepted: accepted }))
  }

  const acceptCookies = () => {
    Cookies.set('cookies-accepted', 'true', {
      expires: state.cookiesExpirationTime,
      path: '/',
    })
    setCookiesAccepted(true)
  }

  useEffect(() => setCookiesAccepted(Cookies.get('cookies-accepted') === 'true'), []) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    ...state,
    acceptCookies,
  }
}
